// extracted by mini-css-extract-plugin
module.exports = {"wrappedDataGridStyle":"src-components-DataGridContainer-index-module__wrappedDataGridStyle--ylXZV"};